/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'
import { FurnitureGachaItemEmissionRate } from '../FurnitureGacha/Common/FurnitureGachaItemEmissionRate'
import { FurnitureGachaRarityEmissionRate } from '../FurnitureGacha/Common/FurnitureGachaRarityEmissionRate'

export const protobufPackage = 'Reality.Reality.Api'

/**
 * <strong>POST /api/v2/furniture_gacha/get_item_list</strong>
 * 家具ガチャ確率表記ページ用のアイテム確立取得
 */
export interface FurnitureGachaGetItemListRequest {
  furnitureGachaId: number
}

export interface FurnitureGachaGetItemListResponse {
  bannerUrl: string
  furnitureGachaItemList: FurnitureGachaItemEmissionRate[]
  furnitureGachaRarityList: FurnitureGachaRarityEmissionRate[]
}

function createBaseFurnitureGachaGetItemListRequest(): FurnitureGachaGetItemListRequest {
  return { furnitureGachaId: 0 }
}

export const FurnitureGachaGetItemListRequest = {
  encode(
    message: FurnitureGachaGetItemListRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.furnitureGachaId !== 0) {
      writer.uint32(8).int64(message.furnitureGachaId)
    }
    return writer
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FurnitureGachaGetItemListRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFurnitureGachaGetItemListRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.furnitureGachaId = longToNumber(reader.int64() as Long)
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): FurnitureGachaGetItemListRequest {
    return {
      furnitureGachaId: isSet(object.furnitureGachaId)
        ? Number(object.furnitureGachaId)
        : 0,
    }
  },

  toJSON(message: FurnitureGachaGetItemListRequest): unknown {
    const obj: any = {}
    message.furnitureGachaId !== undefined &&
      (obj.furnitureGachaId = Math.round(message.furnitureGachaId))
    return obj
  },

  fromPartial<
    I extends Exact<DeepPartial<FurnitureGachaGetItemListRequest>, I>
  >(object: I): FurnitureGachaGetItemListRequest {
    const message = createBaseFurnitureGachaGetItemListRequest()
    message.furnitureGachaId = object.furnitureGachaId ?? 0
    return message
  },
}

function createBaseFurnitureGachaGetItemListResponse(): FurnitureGachaGetItemListResponse {
  return {
    bannerUrl: '',
    furnitureGachaItemList: [],
    furnitureGachaRarityList: [],
  }
}

export const FurnitureGachaGetItemListResponse = {
  encode(
    message: FurnitureGachaGetItemListResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.bannerUrl !== '') {
      writer.uint32(10).string(message.bannerUrl)
    }
    for (const v of message.furnitureGachaItemList) {
      FurnitureGachaItemEmissionRate.encode(
        v!,
        writer.uint32(18).fork()
      ).ldelim()
    }
    for (const v of message.furnitureGachaRarityList) {
      FurnitureGachaRarityEmissionRate.encode(
        v!,
        writer.uint32(26).fork()
      ).ldelim()
    }
    return writer
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FurnitureGachaGetItemListResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFurnitureGachaGetItemListResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.bannerUrl = reader.string()
          break
        case 2:
          message.furnitureGachaItemList.push(
            FurnitureGachaItemEmissionRate.decode(reader, reader.uint32())
          )
          break
        case 3:
          message.furnitureGachaRarityList.push(
            FurnitureGachaRarityEmissionRate.decode(reader, reader.uint32())
          )
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): FurnitureGachaGetItemListResponse {
    return {
      bannerUrl: isSet(object.bannerUrl) ? String(object.bannerUrl) : '',
      furnitureGachaItemList: Array.isArray(object?.furnitureGachaItemList)
        ? object.furnitureGachaItemList.map((e: any) =>
            FurnitureGachaItemEmissionRate.fromJSON(e)
          )
        : [],
      furnitureGachaRarityList: Array.isArray(object?.furnitureGachaRarityList)
        ? object.furnitureGachaRarityList.map((e: any) =>
            FurnitureGachaRarityEmissionRate.fromJSON(e)
          )
        : [],
    }
  },

  toJSON(message: FurnitureGachaGetItemListResponse): unknown {
    const obj: any = {}
    message.bannerUrl !== undefined && (obj.bannerUrl = message.bannerUrl)
    if (message.furnitureGachaItemList) {
      obj.furnitureGachaItemList = message.furnitureGachaItemList.map((e) =>
        e ? FurnitureGachaItemEmissionRate.toJSON(e) : undefined
      )
    } else {
      obj.furnitureGachaItemList = []
    }
    if (message.furnitureGachaRarityList) {
      obj.furnitureGachaRarityList = message.furnitureGachaRarityList.map((e) =>
        e ? FurnitureGachaRarityEmissionRate.toJSON(e) : undefined
      )
    } else {
      obj.furnitureGachaRarityList = []
    }
    return obj
  },

  fromPartial<
    I extends Exact<DeepPartial<FurnitureGachaGetItemListResponse>, I>
  >(object: I): FurnitureGachaGetItemListResponse {
    const message = createBaseFurnitureGachaGetItemListResponse()
    message.bannerUrl = object.bannerUrl ?? ''
    message.furnitureGachaItemList =
      object.furnitureGachaItemList?.map((e) =>
        FurnitureGachaItemEmissionRate.fromPartial(e)
      ) || []
    message.furnitureGachaRarityList =
      object.furnitureGachaRarityList?.map((e) =>
        FurnitureGachaRarityEmissionRate.fromPartial(e)
      ) || []
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
